import React, { useState, useEffect, useRef, useId, useMemo } from 'react';
import ReactApexChart from "react-apexcharts";
import ApexCharts from "apexcharts";
import { Typography } from '@mui/material';

import Progress from '../item/progress'

export default function TreemapSoilRain(props) {

  const [srData, setSrData] = useState([]);
  const [isNoData, setIsNoData] = useState(false);
  // チャートごとの一意のキー
  const chartId = useId();

  // チャート情報を格納
  const setChartData = (data) => {

    let series_ary = []
    data.map(item => {
      series_ary.push({
        x: item.city_name,
        y: item.sr_lv_max,
        fillColor: props.setColor(item.sr_lv_max).color,
        custom: {
          name: item.city_name,
          code: item.city_code,
          lng: item.area_lng,
          lat: item.area_lat,
          sr_lv: item.sr_lv_max,
          sr_val: item.sr_val_max
        }
      })
    })

    // データをステイタスに格納
    setSrData(series_ary)
  }

  // ローディング終了
  const loadingEnd = () => {
    props.setReady(prev => {
      const updated = { ...prev };
      props.isReadyKey.forEach(key => {
        if (key in updated) {
          updated[key] = true;
        }
      });
      return updated;
    });
  }

  const series = useMemo(() => {
    return [
      {
        // name: '',
        data: srData
      },
    ];
  }, [srData]);

  // データ更新が完了したらローディング終了
  useEffect(() => {
    // setChartReady(true);
    loadingEnd()
  }, [srData]);

  // 定期監視用
  useEffect(() => {

    if (props.treemapData === null) {
      setIsNoData(true)
      loadingEnd()
      return
    }
    if (props.treemapData && props.treemapData.length > 0) {
      setChartData(props.treemapData)
    }
    setIsNoData(false)
    loadingEnd()
    // 依存関係の「dateArray」は削除しないでください。
    // これがないとprops.allRankDataに変化がない場合にローディングが消えなくなるので
  }, [props.dateArray, props.treemapData]);

  useEffect(() => {

    if (props.treemapData === null) {
      setIsNoData(true)
      loadingEnd()
      return
    }
    if (props.treemapData && props.treemapData.length > 0) {
      setChartData(props.treemapData)
    }
    setIsNoData(false)
    loadingEnd()

    return () => {
      ApexCharts.exec(chartId, 'destroy'); // 明示的に破棄
    };
  }, []);

  // セル内の文字色、境界線の色を変更
  const updateLabelStyle = (chartContext) => {
    // 境界線の色
    const rects = chartContext.el.querySelectorAll('.apexcharts-treemap-rect');
    rects.forEach((rect) => {
      rect.setAttribute('stroke', '#000000'); // 黒色に変更
    });

    // セル内の文字色
    const labels = chartContext.el.querySelectorAll('.apexcharts-datalabel');
    const data = chartContext.w.config.series[0].data;
    labels.forEach((el, i) => {
      const val = data[i].custom.sr_lv; // ← 値に応じて動的処理
      el.setAttribute('fill', props.setColor(val).font_color);
    });
  }

  const options = useMemo(() => ({
    legend: {
      show: false
    },
    chart: {
      height: '100%',
      type: 'treemap',
      toolbar: {
        show: false,
      },
      events: {
        mounted(chartContext) {
          setTimeout(() => updateLabelStyle(chartContext), 50);
        },
        updated(chartContext) {
          setTimeout(() => updateLabelStyle(chartContext), 50);
        },
        dataPointSelection: (event, chartContext, config) => {

          const seriesIndex = config.seriesIndex;
          const dataPointIndex = config.dataPointIndex;
          if (seriesIndex === -1 || dataPointIndex === -1) return; // クリック対象がない場合ガード
          const clickedItem = series[seriesIndex].data[dataPointIndex];
          const cityCode = clickedItem.custom.code;
          props.clickHandler([clickedItem.custom.lng, clickedItem.custom.lat], [cityCode])
        },

      }
    },
    fill: {
      type: 'solid',
      colors: []
    },
    dataLabels: {
      enabled: true,
      formatter: function (text, opts) {
        if (text.length > 6) {
          return text = text.slice(0, 2) + '…' + text.slice(0, -1).slice(-3);
        }
        return text;
      },
      style: {
        fontSize: '10px',
        fontWeight: 'bold',
        colors: ['#fff']
      }
    },
    plotOptions: {
      treemap: {
        distributed: false,
        enableShades: false,
        borderRadius: 1,    // 角丸をなくす
        stroke: {
          width: 1,          // 線の太さ（0で非表示）
          color: '#000000'    // 枠線を黒に
        },
        colorScale: {
          enabled: false 
        }
      }
    }
  }), [series]);

  // チャートのデータが更新されたら強制再描画
  useEffect(() => {
    if (series && series.length > 0) {
      ApexCharts.exec(chartId,
        "updateSeries", series);
    }
  }, [series]);


  return (
    <>
      {/* チャート部分 */}
      {!props.isReadyFlg ?
        <Progress />
        // <ChartSkeleton />
        :
        isNoData ?
          <Typography
            sx={{
              fontSize: '0.75rem',
              fontWeight: 'bold',
              color: 'white',
            }}
          >
            対象データがありません
          </Typography>
          :
          <ReactApexChart
            options={options}
            series={series}
            type="treemap"
            height="100%"
            width="100%"
            style={{ visibility: props.isReadyFlg ? 'visible' : 'hidden' }}
          />
      }
    </>
  );
}